import { converterDataHoraBr } from "_utils/Data";
import { ILoteEstampagem, StatusLote } from "../../../interfaces/ILoteEstampagem";

const STATUS_BADGE: Record<StatusLote, string> = {
  ABERTO: "bg-success",
  FECHADO: "bg-secondary",
  ENVIADO: "bg-primary",
  ENTREGUE: "bg-info text-dark",
  FINALIZADO: "bg-dark",
};

interface LoteInfoCardProps {
  lote: ILoteEstampagem;
  itensCount: number;
}

export function LoteInfoCard({ lote, itensCount }: LoteInfoCardProps) {
  return (
    <div
      className="mb-3 p-3 rounded border bg-light"
      style={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(200px, 1fr))", gap: "8px 24px" }}
    >
      <div><small className="text-muted d-block">Empresa</small><strong>{lote.nomeEmpresa}</strong></div>
      <div><small className="text-muted d-block">Tipo</small><strong>{lote.tipo === "TAGS" ? "Tags" : "Estampagem"}</strong></div>
      <div>
        <small className="text-muted d-block">Status</small>
        <span className={`badge ${STATUS_BADGE[lote.status]}`}>{lote.status}</span>
      </div>
      <div><small className="text-muted d-block">Local de entrega</small><strong>{lote.localEntrega ?? "—"}</strong></div>
      <div><small className="text-muted d-block">Qtd. de itens</small><strong>{itensCount}</strong></div>
      <div><small className="text-muted d-block">Criado em</small><strong>{converterDataHoraBr(lote.criadoEm)}</strong></div>
      {lote.finalizadoEm && (
        <div><small className="text-muted d-block">Finalizado em</small><strong>{converterDataHoraBr(lote.finalizadoEm)}</strong></div>
      )}
    </div>
  );
}
